import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'
import { Transform } from 'class-transformer'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateSubjectDto {
  @ApiProperty({
    description: 'ID de la matière (UUID)',
    type: 'string',
    format: 'uuid',
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty({ message: "L'ID est obligatoire" })
  @IsUUID('4', { message: "L'ID doit être un UUID v4 valide" })
  @Transform(({ value }: { value: string }) => value?.trim())
  id!: string

  @ApiProperty({ type: 'string', description: 'Code de la matière', example: 'MATH' })
  @IsNotEmpty({ message: 'Le code est obligatoire' })
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim())
  code!: string

  @ApiProperty({
    type: 'string',
    description: 'Libellé de la matière',
    example: 'Mathématiques',
  })
  @IsNotEmpty({ message: 'Le libellé est obligatoire' })
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim())
  label!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description de la matière' })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim() || undefined)
  description?: string

  @ApiProperty({
    type: 'string',
    description: 'ID du type de matière (UUID v4)',
    example: '4d2e0d1f-7feb-4adc-80fe-dc2c5263fd31',
  })
  @IsNotEmpty({ message: 'Le type de matière est obligatoire' })
  @IsUUID('4', { message: 'Le typeId doit être un UUID v4 valide' })
  @Transform(({ value }: { value: string }) => value?.trim())
  typeId!: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Couleur de la matière (format hexadécimal)',
    example: '#FF5733',
  })
  @IsOptional()
  @IsString()
  @Transform(({ value }: { value: string }) => value?.trim()?.toUpperCase() || undefined)
  color?: string
}
